import { render, staticRenderFns } from "./FileOpenModal.vue?vue&type=template&id=2824ebde"
import script from "./FileOpenModal.vue?vue&type=script&lang=js"
export * from "./FileOpenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports